import {
  AccordionDetails,
  Alert,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Confirm } from 'src/components/common/Confirm';
import { FileUpload } from 'src/components/common/FileUpload';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { sendRequest } from 'src/hooks/useFetch';
import { store, useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch } from 'src/store/hooks';
import { useIMVCheckListPage } from '../IMVChecklist/UseIMVChecklistPage';

const InfomredConsentProcess: React.FunctionComponent<any> = ({
  handleCheck,
  isDisable,
  validationObj,
  fileObjects2,
  setFileObjects2,
  setSection3,
  section3,
  setIsChanged,
  setIsDataUpdate,
  disable
}) => {
  const [newAr, setNewAr] = useState<any>([]);
  const [isSubmitEnable, setIsSubmitEnable] = useState(false);
  const [openUploadDocument, setOpenUploadDocument] = React.useState(false);
  const dispatchApp = useAppDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { uploadDocument, uploadDocumentData } = useIMVCheckListPage();
  const { checkPermission } = usePermissionWrapper();
  const updateIMVreportPermission = checkPermission('update_imvreport');
  const uploadIMVreportdocPermission = checkPermission('upload_imvreportdocument');
  const deleteIMVreportdocPermission = checkPermission('delete_imvreportdocument');
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const dispatch = useDispatch();

  const setDocumentUploadInfo = () => {
    const newElement = document.createElement('div');
    newElement.innerHTML =
      '<span class="other-doc-upload-message"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit css-1vooibu-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="InfoOutlinedIcon"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"></path></svg> Documents uploaded here are not stored in eTMF</span>';
    const referenceElement: any = document.querySelector('.pi-document-upload');
    referenceElement?.parentNode.insertBefore(newElement, referenceElement.nextSibling);
  };

  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `; // const maxFileSize=5000000;

    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    }
    return message;
  };
  const handleClose = () => {
    // do nothing
  };

  useEffect(() => {
    if (section3.stdy_imvrp_cons_attach2) {
      const files: any[] = [];
      const ids = section3?.stdy_imvrp_cons_attach2?.split(',');
      ids.map((id: any) => {
        const trim = id.trim();
        files.push(trim);
      });
      uploadDocument({ data: files });
    }
  }, [section3]);

  useEffect(() => {
    if (uploadDocumentData) {
      setFileObjects2(uploadDocumentData);
    }
  }, [uploadDocumentData]);

  const handleClickOpenUploadDocument = () => {
    setOpenUploadDocument(true);
    setTimeout(() => {
      setDocumentUploadInfo();
    }, 100);
  };

  const handleCloseUploadDocument = () => {
    setOpenUploadDocument(false);
  };

  const uploadOtherDocuments = async (files: any): Promise<any> => {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      const options = {
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME
        }
      };
      const response: any = await sendRequest('sqreport_filemaster_Other_Upload_Documents', options);

      return response;
    } catch {
      dispatchApp(setMessage({ msgDetails: 'Error while file uploading.', severity: 'error' }));

      return Promise.reject();
    }
  };
  const uploadDataFile = async (): Promise<any> => {
    if (newAr.length > 0) {
      const fileExist = newAr.filter((o1: any) => fileObjects2.some((o2: any) => o1.path === o2.ctms_raw_file_name));
      if (fileExist.length > 0) {
        store.dispatch(
          dispatchApp(
            setMessage({
              msgDetails: 'The selected document(s) is already present in the successfully uploaded list',
              severity: 'error'
            })
          )
        );
      } else {
        setIsSubmitEnable(true);
        const result = await uploadOtherDocuments(newAr);
        setIsSubmitEnable(false);
        const data: string[] = section3.stdy_imvrp_cons_attach2 ? [section3.stdy_imvrp_cons_attach2] : [];
        result?.map((item: { id: string }) => {
          data.push(item.id);
        });
        setSection3({ ...section3, stdy_imvrp_cons_attach2: data.join(', ') });
        setConfirmExitValue(dispatch, true);
        setIsChanged(true);
        setIsDataUpdate(true);

        if (Array.isArray(result)) {
          setFileObjects2([...fileObjects2, ...result]);
        }
      }
    }
    setOpenUploadDocument(false);
  };

  const handleUploadDocument = () => {
    const nameArr = newAr.map((ele: any) => {
      return ele.name;
    });
    const duplicate = nameArr.some((item: any, idx: number) => {
      return nameArr.indexOf(item) !== idx;
    });
    if (duplicate) {
      dispatchApp(setMessage({ msgDetails: 'Please Remove Duplicate file', severity: 'error' }));
    } else {
      uploadDataFile();
      setIsSubmitEnable(false);
    }
  };

  const DeleteFile = () => {
    setOpenDelete(false);
    const files = fileObjects2.filter((item: any) => item.id !== deleteID);
    setFileObjects2(files);
    const data: string[] = [];
    files?.map((item: { id: string }) => {
      data.push(item.id);
    });
    setSection3({ ...section3, stdy_imvrp_cons_attach2: data.join(', ') });
    setIsDataUpdate(true);
  };

  const handleRemoveItem = async (fileId: any) => {
    setOpenDelete(true);
    setDeleteID(fileId);
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Have any new subjects consented since the last visit? If the answer is yes, please complete Attachment
                No. 2, Cumulative Status of ICFs?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvrp_new_consent}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvrp_new_consent"
                    onChange={e => handleCheck(e, 'section3')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_new_consent == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_new_consent == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvrp_new_consent_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvrp_new_consent_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section3')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                  InputLabelProps={{ shrink: validationObj.stdy_imvrp_new_consent_comm }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Have all new subjects consented/ reconsented in accordance to relevant guidances (GCP/ local
                regulations/ protocol)
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvrp_cons_regulation}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvrp_cons_regulation"
                    onChange={e => handleCheck(e, 'section3')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_cons_regulation == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_cons_regulation == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.75 }}>
                <TextField
                  name="stdy_imvrp_cons_regulation_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvrp_cons_regulation_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section3')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                  InputLabelProps={{ shrink: validationObj.stdy_imvrp_cons_regulation_comm }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item md={7}>
                Informed Consent process/ reconsenting appropriately documented in source documentation?
              </Grid>
              <Grid item md={2}>
                <FormControl sx={{ display: 'flex', width: '140px' }}>
                  <RadioGroup
                    sx={{ justifyContent: 'flex-end' }}
                    value={validationObj.stdy_imvrp_cons_doc}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="stdy_imvrp_cons_doc"
                    onChange={e => handleCheck(e, 'section3')}
                  >
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_cons_doc == 'Y' ? true : false}
                      disabled={!isDisable || disable}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      checked={validationObj.stdy_imvrp_cons_doc == 'N' ? true : false}
                      disabled={!isDisable || disable}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={3} sx={{ mt: -1.25 }}>
                <TextField
                  name="stdy_imvrp_cons_doc_comm"
                  label="Notes"
                  variant="standard"
                  value={validationObj.stdy_imvrp_cons_doc_comm}
                  sx={{ mt: 0 }}
                  onChange={e => handleCheck(e, 'section3')}
                  disabled={!isDisable || disable}
                  inputProps={{ maxLength: 2000 }}
                  InputLabelProps={{ shrink: validationObj.stdy_imvrp_cons_doc_comm }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>

      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-start">
          <Stack spacing={2} direction="row">
            <Button
              variant="contained"
              sx={{ mb: 2, ml: 2 }}
              onClick={handleClickOpenUploadDocument}
              disabled={!uploadIMVreportdocPermission || !updateIMVreportPermission || disable}
            >
              Attachments
            </Button>
            <div>
              <PopupComponent
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openUploadDocument}
                maxWidth="md"
                className="uploadModal"
              >
                <DialogContent>
                  <FileUpload
                    showPreviewsInDropzone={false}
                    className={'uploadFile withFakeBtn multiple'}
                    onChange={files => {
                      if (files.length > 0) {
                        setNewAr([...files]);
                        // setUploadedFiles([...files]);
                        setIsSubmitEnable(true);
                      } else {
                        setIsSubmitEnable(false);
                      }
                    }}
                    isUpload
                    defaultMsg={'Your file upload has been successfully initiated'}
                    successMsg={'Drag and drop your file here or'}
                    fileObjects={[]}
                    maxFileSize={5000000}
                    showPreviews
                    useChipsForPreview
                    previewText=""
                    getDropRejectMessage={handleRejectedMessage}
                    acceptedFiles={[
                      '.jpg',
                      '.jpeg',
                      '.gif',
                      '.png',
                      '.bmp',
                      '.tif',
                      '.tiff',
                      '.psd',
                      '.pdf',
                      '.doc',
                      '.docx',
                      '.xls',
                      '.xlsx'
                    ]}
                  />
                </DialogContent>
                <Alert severity="info" sx={{ mr: 2, ml: 2 }}>
                  Documents uploaded here are not stored in eTMF
                </Alert>
                <DialogActions sx={{ marginTop: '50px' }}>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="text"
                      href="#contained-buttons"
                      className="grey-btn"
                      onClick={handleCloseUploadDocument}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="text"
                      href="#contained-buttons"
                      onClick={handleUploadDocument}
                      disabled={!isSubmitEnable}
                    >
                      Submit
                    </Button>
                  </Stack>
                </DialogActions>
              </PopupComponent>
            </div>
          </Stack>
        </Grid>
        <Grid item md={12} pl={2} pt={0} className={fileObjects2.length > 0 ? 'rightFadedOverflowHidden' : ''}>
          <Stack direction="row" className="overflowHiddenStack">
            {fileObjects2.map((item: any) => {
              return (
                <Chip
                  disabled={!deleteIMVreportdocPermission || !updateIMVreportPermission}
                  key={item.id}
                  label={item.ctms_raw_file_name}
                  variant="outlined"
                  onDelete={() => handleRemoveItem(item.id)}
                  color="primary"
                  sx={{ fontSize: '13px', fontWeight: '700', mr: 1, mb: 1, maxWidth: '32%' }}
                  size="small"
                />
              );
            })}
          </Stack>
        </Grid>
        <Confirm
          isOpen={openDelete}
          message="Are you sure you want to delete the uploaded document?"
          onCancel={() => setOpenDelete(false)}
          onConfirm={() => {
            DeleteFile();
          }}
          btnClassName="grey-btn"
        />
      </Grid>
    </>
  );
};

export default InfomredConsentProcess;
